export default __webpack_public_path__ + "static/media/ABFS.d2e0f2bf.png";